import styled from "styled-components";
import { Paragraph2 } from "../../../components";
import { colors } from "../../../consts";

export const LangTitle = styled(Paragraph2)`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  display: flex;
  align-items: center;
  gap: 15px;
  color: ${colors.RAISIN_100};
  margin-right: 20px;
`;

export const MissingKeysCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 20px;
  min-width: 20px;

  font-size: 14px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.05em;
  color: #fff;

  background-color: ${colors.ERROR};
  border-radius: 50%;
  cursor: pointer;
`;

export const FileNameTitle = styled(Paragraph2)`
  font-size: 16px;
  line-height: 26px;
  font-weight: ${(props) => (props?.isEmpty ? 400 : 500)};
  color: ${colors.RAISIN_100};
`;
